import { ArrowLeft, CheckCircle, BookOpen, MessageCircle, Languages, Heart } from 'lucide-react';

export default function TurkceAciklamaPage() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-red-950 via-red-900 to-orange-900">
      {/* Header */}
      <div className="bg-white/10 backdrop-blur-xl border-b border-white/20">
        <div className="container mx-auto px-4 py-6">
          <button
            onClick={() => window.location.href = '/'}
            className="flex items-center gap-2 text-white hover:text-orange-300 transition-all"
          >
            <ArrowLeft className="w-5 h-5" />
            Ana Sayfaya Dön
          </button>
        </div>
      </div>

      <div className="container mx-auto px-4 py-16">
        <div className="max-w-5xl mx-auto">
          {/* Hero */}
          <div className="text-center mb-16">
            <div className="inline-flex items-center gap-3 bg-gradient-to-r from-red-600 to-orange-600 text-white px-8 py-4 rounded-full font-bold text-xl mb-6 shadow-2xl animate-pulse">
              <Languages className="w-8 h-8" />
              <span>🇹🇷 GERÇEK TÜRKÇE AÇIKLAMA</span>
            </div>
            <h1 className="text-7xl font-black text-white mb-6">
              Anlaşılır <span className="text-orange-400">Türkçe</span> ile Öğren!
            </h1>
            <p className="text-2xl text-white/90 leading-relaxed max-w-3xl mx-auto">
              Sorular ve açıklamalar <strong className="text-orange-400">profesyonel tercümanlar tarafından</strong> Türkçeye çevrildi. 
              Karmaşık terimler yok, <strong>herkesin anlayabileceği sade Türkçe</strong>!
            </p>
          </div>

          {/* Why Turkish Matters */}
          <div className="bg-gradient-to-br from-red-600 to-orange-700 rounded-3xl p-12 mb-12 shadow-2xl">
            <h2 className="text-4xl font-black text-white mb-8 text-center">
              Neden Türkçe Bu Kadar Önemli? 🇹🇷
            </h2>
            <div className="space-y-6 text-white text-xl leading-relaxed">
              <p className="flex items-start gap-4">
                <Heart className="w-8 h-8 flex-shrink-0 mt-1 text-orange-300" />
                <span>
                  <strong>Anadilinde öğrenmek her zaman daha kolay!</strong> Trafik kurallarını İsveççe 
                  ezberlemek yerine, <strong className="text-yellow-300">Türkçe anlayarak</strong> öğrenirsiniz.
                </span>
              </p>
              <p className="flex items-start gap-4">
                <Heart className="w-8 h-8 flex-shrink-0 mt-1 text-orange-300" />
                <span>
                  <strong>Karmaşık terimler basitleştirildi!</strong> "Förkörsrätt" (öncelik hakkı), "Körbana" (şerit), 
                  "Backspegel" (dikiz aynası) gibi terimler <strong className="text-yellow-300">sade Türkçe</strong> ile açıklanıyor.
                </span>
              </p>
              <p className="flex items-start gap-4">
                <Heart className="w-8 h-8 flex-shrink-0 mt-1 text-orange-300" />
                <span>
                  <strong>Sadece çeviri değil, tam açıklama!</strong> Neden o cevabın doğru olduğunu 
                  <strong className="text-yellow-300"> detaylıca ve anlaşılır şekilde</strong> öğrenirsiniz.
                </span>
              </p>
            </div>
          </div>

          {/* Features Grid */}
          <div className="grid md:grid-cols-2 gap-8 mb-16">
            <div className="bg-white/10 backdrop-blur-xl border border-white/20 rounded-3xl p-8">
              <div className="w-16 h-16 bg-gradient-to-br from-orange-500 to-red-600 rounded-2xl flex items-center justify-center mb-4">
                <BookOpen className="w-8 h-8 text-white" />
              </div>
              <h3 className="text-3xl font-black text-white mb-4">Profesyonel Tercüme</h3>
              <p className="text-white/80 text-lg leading-relaxed">
                Tüm sorular ve açıklamalar <strong>ana dili Türkçe olan profesyonel tercümanlar</strong> 
                tarafından çevrildi. Google Translate değil, <strong className="text-orange-300">gerçek Türkçe</strong>!
              </p>
            </div>

            <div className="bg-white/10 backdrop-blur-xl border border-white/20 rounded-3xl p-8">
              <div className="w-16 h-16 bg-gradient-to-br from-red-500 to-orange-600 rounded-2xl flex items-center justify-center mb-4">
                <MessageCircle className="w-8 h-8 text-white" />
              </div>
              <h3 className="text-3xl font-black text-white mb-4">Günlük Dil Kullanımı</h3>
              <p className="text-white/80 text-lg leading-relaxed">
                Ağır terimler yerine <strong>günlük hayatta kullandığınız Türkçe</strong> ile yazıldı. 
                Okurken zorlanmazsınız, <strong className="text-orange-300">anında anlarsınız</strong>!
              </p>
            </div>

            <div className="bg-white/10 backdrop-blur-xl border border-white/20 rounded-3xl p-8">
              <div className="w-16 h-16 bg-gradient-to-br from-green-500 to-emerald-600 rounded-2xl flex items-center justify-center mb-4">
                <CheckCircle className="w-8 h-8 text-white" />
              </div>
              <h3 className="text-3xl font-black text-white mb-4">Detaylı Açıklamalar</h3>
              <p className="text-white/80 text-lg leading-relaxed">
                Sadece "doğru cevap bu" demiyoruz. <strong>Neden doğru, neden diğerleri yanlış</strong> 
                - tüm mantık Türkçe anlatılıyor. <strong className="text-green-300">Öğrenerek ilerlersiniz</strong>!
              </p>
            </div>

            <div className="bg-white/10 backdrop-blur-xl border border-white/20 rounded-3xl p-8">
              <div className="w-16 h-16 bg-gradient-to-br from-orange-500 to-red-600 rounded-2xl flex items-center justify-center mb-4">
                <Languages className="w-8 h-8 text-white" />
              </div>
              <h3 className="text-3xl font-black text-white mb-4">Doğru İsveççe Terimler</h3>
              <p className="text-white/80 text-lg leading-relaxed">
                Sınavda göreceğiniz <strong>gerçek İsveççe terimler Türkçe karşılıklarıyla</strong> öğretiliyor. 
                "Omkörning" = sollama, "Hastighetsbegränsning" = hız sınırı gibi. <strong className="text-orange-300">Hem anlıyorsunuz, hem hazırlanıyorsunuz</strong>!
              </p>
            </div>
          </div>

          {/* Example Box */}
          <div className="bg-white/10 backdrop-blur-xl border-2 border-yellow-400/50 rounded-3xl p-10 mb-12">
            <h3 className="text-3xl font-black text-yellow-400 mb-6 text-center">
              📝 Örnek Açıklama Farkı
            </h3>
            <div className="grid md:grid-cols-2 gap-6">
              <div className="bg-red-500/20 border-2 border-red-500 rounded-2xl p-6">
                <p className="text-red-300 font-bold mb-3">❌ Kötü Çeviri (Google Translate):</p>
                <p className="text-white/80 text-sm italic">
                  "När du kör i en körbana ska du uppmärksamma hastighetsbegränsning för omkörning..."
                </p>
                <p className="text-red-300 mt-3 text-sm">🤔 İsveççe karmaşık ve anlaşılmaz!</p>
              </div>
              <div className="bg-green-500/20 border-2 border-green-500 rounded-2xl p-6">
                <p className="text-green-300 font-bold mb-3">✅ Bizim Açıklama (Gerçek Türkçe):</p>
                <p className="text-white text-sm">
                  "Şeritte (körbana) ilerlerken, sollama (omkörning) için hız sınırına (hastighetsbegränsning) dikkat etmelisiniz."
                </p>
                <p className="text-green-300 mt-3 text-sm">😊 Hem Türkçe hem İsveççe öğreniyorsunuz!</p>
              </div>
            </div>
            <p className="text-white/70 text-center mt-6 text-sm">
              ℹ️ İsveççe terimler parantez içinde gösterilir - hem anlıyorsunuz hem öğreniyorsunuz!
            </p>
          </div>

          {/* CTA */}
          <div className="bg-gradient-to-r from-pink-600 to-purple-600 rounded-3xl p-12 text-center shadow-2xl">
            <h2 className="text-5xl font-black text-white mb-6">
              Türkçe Açıklamalarla Öğrenmeye Başla! 🎯
            </h2>
            <p className="text-2xl text-white/90 mb-8 leading-relaxed">
              Premium üyelikle <strong>tüm soruların detaylı Türkçe açıklamasına</strong> erişin!
            </p>
            <button
              onClick={() => {
                // Ana sayfaya git ve login modal'ı aç
                window.location.href = '/?action=login';
              }}
              className="bg-white text-purple-600 px-12 py-6 rounded-2xl font-black text-2xl hover:scale-110 transition-all shadow-2xl"
            >
              💎 Premium'a Geç - Türkçe Öğren!
            </button>
            <p className="text-white/80 mt-6 text-lg">
              ✅ Ücretsiz deneme • ✅ Anında başlangıç • ✅ Mobil uyumlu
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
